const mutations = {
  retrieveToken(state, token) {
    state.token = token;
  },
  destroyToken(state) {
    state.token = null;
    state.subUser = null;
  },

  // Setea la identidad del sub-usuario (null = es el anfitrión)
  SET_SUB_USER(state, subUser) {
    state.subUser = subUser;
    if (subUser) {
      localStorage.setItem("sub_user", JSON.stringify(subUser));
    } else {
      localStorage.removeItem("sub_user");
    }
  },

  // ✅ NUEVA: setear propiedad activa por defecto
  SET_ACTIVE_PROPERTY(state, propertyId) {
    const id = Number(propertyId);

    state.propiedadActiva = id;
    state.selectPropertyView = id; // (por compatibilidad con tu lógica vieja)

    localStorage.setItem("propiedadActiva", String(id));
    localStorage.setItem("selectPropertyView", String(id));
  },
  
  setUserGlobal(state, user) {
    // Validamos que el nuevo 'user' no sea nulo o vacío y que sea diferente del actual
    if (user && JSON.stringify(state.userRoot) !== JSON.stringify(user)) {
      state.userRoot = user; // Actualizamos el estado
      localStorage.setItem("user", JSON.stringify(user)); // Guardamos en localStorage
    }
  },

  UPDATE_WEB_RESERVATIONS_GLOBAL(state, enabled) {
    if (state.userRoot) {
      state.userRoot.enable_web_reservations = enabled;
      localStorage.setItem("user", JSON.stringify(state.userRoot));
    }
  },

  SET_MODAL_BOOKING_VISIBILITY(state, isVisible) {
    state.isVisibleModalBooking = isVisible;
  },

  SET_SELECTED_BOOKING_RANGE(state, range) {
    state.selectedBookingRange = range;
  },

  SET_PROPERTY_SELECT(state, property) {
    state.propertySelect = property;
  },

  SET_BOOKING_TO_EDIT(state, booking) {
    state.bookingToEdit = booking;
  },
  CLEAR_BOOKING_TO_EDIT(state) {
    state.bookingToEdit = null;
  },

  UPDATE_USER_PAYMENT_TYPE(state, paymentType) {
    // Actualizar el estado de Vuex
    state.userRoot.direct_booking_payment_type = paymentType;

    // Obtener el usuario del localStorage
    const userString = localStorage.getItem("user");
    if (userString) {
      try {
        const user = JSON.parse(userString);

        // Actualizar el campo payment type
        user.direct_booking_payment_type = paymentType;

        // Guardar de vuelta en localStorage
        localStorage.setItem("user", JSON.stringify(user));

      } catch (error) {
        console.error("Error parsing user from localStorage:", error);
      }
    } else {
      console.warn("No user found in localStorage");
    }
  },
  // ── Tipo de panel (hotel / apartment) ───────────────────────────────────
  setPanelType(state, type) {
    if (type === "hotel" || type === "apartment") {
      state.panelType = type;
      localStorage.setItem("wc_panel_type", type);
    }
  },
};

export default mutations;
